"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COOKIE_THEME_KEY = exports.COOKIE_APP_PREFIX = void 0;
exports.COOKIE_APP_PREFIX = '';
exports.COOKIE_THEME_KEY = '_UserTheme';
